import React from 'react'
import { WidgetCard } from '../style'
import { MilchmengeContainer } from '../widgets/MilkAmountWidget/style'
import { SkeletonLine, SkeletonBox } from './skeleton.style'

const MilkAmountWidgetSkeleton: React.FC = () => (
  <WidgetCard>
    <SkeletonLine width='100px' height='18px' style={{ marginBottom: '15px' }} />
    <MilchmengeContainer>
      <SkeletonBox height='280px' />
    </MilchmengeContainer>
  </WidgetCard>
)

export default MilkAmountWidgetSkeleton
